<div class="container p-6 mx-auto">
  <div class="bg-white rounded-lg shadow-lg">
    <div class="flex items-center justify-between p-6 border-b">
      <div class="flex items-center justify-between gap-4">
        <!-- Première colonne -->
        <div class="flex items-center gap-4">
          <button (click)="goToHome()"
            class="flex items-center gap-2 px-4 py-2 text-white transition-colors bg-gray-600 rounded-lg hover:bg-gray-700">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" aria-hidden="true" focusable="false">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Accueil
          </button>
          <h1 class="text-2xl font-bold text-gray-800">Fiche d'Inspection</h1>
        </div>

        <!-- Deuxième colonne - Statut -->
        <div class="flex items-center gap-4">
          <span class="text-lg font-medium text-gray-700">Statut:</span>
          <span [ngClass]="{
      'bg-green-100 text-green-800 border border-green-200': ficheData.statut === true,
      'bg-red-100 text-red-800 border border-red-200': ficheData.statut === false
    }" class="flex items-center gap-2 px-4 py-2 text-sm font-medium transition-all border rounded-lg">
            <svg *ngIf="ficheData.statut" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none"
              viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
            <svg *ngIf="!ficheData.statut" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none"
              viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
            {{ ficheData.statut ? 'Actif' : 'Inactif' }}
          </span>
        </div>
      </div>
      <button (click)="downloadPdf()"
        class="flex items-center gap-2 px-6 py-2 text-white transition-colors bg-blue-600 rounded-lg hover:bg-blue-700"
        [disabled]="loading || error">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          aria-hidden="true" focusable="false">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
        </svg>
        Télécharger PDF
      </button>
    </div>

    <div class="p-6">
      <div *ngIf="loading" class="flex items-center justify-center py-12">
        <div class="w-12 h-12 border-b-2 border-blue-600 rounded-full animate-spin"></div>
        <span class="ml-3 text-gray-600">Chargement de la fiche...</span>
      </div>

      <div *ngIf="error" class="p-4 mb-6 border border-red-200 rounded-lg bg-red-50">
        <div class="flex items-center">
          <svg class="w-5 h-5 mr-2 text-red-600" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true"
            focusable="false">
            <path fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clip-rule="evenodd"></path>
          </svg>
          <span class="text-red-800">{{ error }}</span>
        </div>
        <button (click)="loadFicheData()"
          class="px-4 py-2 mt-3 text-sm text-white transition-colors bg-red-600 rounded hover:bg-red-700">
          Réessayer
        </button>
      </div>

      <div *ngIf="ficheData && !loading && !error" class="w-full">
        <div class="flex items-center justify-between p-4 mb-4 border border-gray-200 rounded-lg bg-gray-50">
          <div class="flex items-center gap-4">
            <button (click)="previousPage()" [disabled]="currentPage <= 1"
              class="flex items-center gap-2 px-3 py-2 text-white transition-colors bg-blue-600 rounded hover:bg-blue-700 disabled:bg-gray-400">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" aria-hidden="true" focusable="false">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg>
              Précédent
            </button>

            <span class="text-gray-700">
              Page {{ currentPage }} sur {{ totalPages }}
            </span>

            <button (click)="nextPage()" [disabled]="currentPage >= totalPages"
              class="flex items-center gap-2 px-3 py-2 text-white transition-colors bg-blue-600 rounded hover:bg-blue-700 disabled:bg-gray-400">
              Suivant
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" aria-hidden="true" focusable="false">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          <div class="flex items-center gap-2">
            <label for="pdf-zoom" class="text-gray-700">Zoom&nbsp;:</label>
            <select id="pdf-zoom" [(ngModel)]="zoom" class="px-2 py-1 text-sm border border-gray-300 rounded">
              <option value="0.5">50%</option>
              <option value="0.75">75%</option>
              <option value="1">100%</option>
              <option value="1.25">125%</option>
              <option value="1.5">150%</option>
              <option value="2">200%</option>
            </select>
          </div>
        </div>

        <div class="overflow-hidden border border-gray-300 rounded-lg pdf-container">
          <pdf-viewer *ngIf="pdfSrc" [src]="pdfSrc" [page]="currentPage" [zoom]="zoom" [render-text]="true"
            [original-size]="false" [fit-to-page]="false" [show-all]="false" (after-load-complete)="onPdfLoaded($event)"
            (page-rendered)="onPageRendered($event)" style="display: block; width: 100%; height: 100%;">
          </pdf-viewer>

          <div *ngIf="!pdfSrc" class="flex items-center justify-center h-full text-gray-500">
            Chargement du PDF...
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
